import openOldTask from 'fsrc/Sidemenu/utils/openOldTask.js';

export default (taskId: number) => openOldTask(+taskId);
